
$(function(){
  // ページ内リンク
  var pageLink=$('[href^="#"]');
  $(pageLink).click(function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position=target.offset().top;
    $("html, body").animate({scrollTop:position}, 500, "swing");
    return false;
  });
  // スクロールアクション
  $(window).on('load scroll',function(){
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    $('.scroll_action').each(function (){
        var This =$(this);
        var elemPos = This.offset().top;
        var w = $( window ).width() ;
        if(This.hasClass('bottom_action')){
          var triggerHeight = windowHeight*0.1;
        }else{
          var triggerHeight = windowHeight*0.25;
        }
        if (scroll > elemPos - windowHeight + triggerHeight){
          This.addClass('active');
        }
    });
  });

  $('.mv_link').hover(function(){
    var num = $(this).data('n');
    var line = '.mv_line'+num;
    $(line).css('z-index','20');
    $(line).addClass('show');
  },
  function(){
    var num = $(this).data('n');
    var line = '.mv_line'+num;
    $(line).css('z-index','1');
    $(line).removeClass('show');
  }
  );
  $('.mv_link3').hover(function(){
    $('.mv_line4').css('opacity',0);
  },
  function(){
    $('.mv_line4').css('opacity',1);
  }
  );
  $('.mv_link.group5').hover(function(){
    $('.mv_line8').css('opacity',0);
  },
  function(){
    $('.mv_line8').css('opacity',1);
  }
  );

  $('.switch ul li').click(function(){
    var color = $(this).data('color');
    $('.wrapper').attr('id',color);
  });

});
